export default "__VITE_ASSET__b188f4a4__"